import { context } from '../services';

/**
 * Adds an experiment to the context, with an active or not active flag.
 * @param {string} experimentName - the name of the experiment
 * @param {boolean }isOn - whether the experiment is active or not
 * */
export function addExperimentToContext(experimentName: string, isOn: boolean): void {
	context.set(`experiments.${experimentName}`, isOn);
}

/**
 * Checks whether at least one of the passed in experiments is turned on.
 * @param {string[]} experimentNames - the names of the experiments for checking whether they're active or not
 * */
export function isOneOfExperimentsActiveFromContext(experimentNames: string[]): boolean {
	return experimentNames.some((expName) => context.get(`experiments.${expName}`));
}
